import type { Pair } from '../messages';

/**
 * A single saved card: its key-value rows, the edit form, the collections it appears in and
 * the delete dialog. Field labels here repeat `playlists.fieldTitle` and friends only where the
 * Russian wording is identical — otherwise the keys stay separate.
 */
export const item = {
  'item.similarType': [
    'Страница похожа на «{found}», тип оставил «{kept}» — поменяйте, если нужно',
    'This page looks like “{found}”, but the type stayed “{kept}” — change it if needed',
  ],
  'item.developer': ['Разработчик', 'Developer'],
  'item.publisher': ['Издатель', 'Publisher'],
  'item.genre': ['Жанр', 'Genre'],
  'item.platforms': ['Платформы', 'Platforms'],
  'item.year': ['Год', 'Year'],
  'item.updated': ['Карточка обновлена', 'Card updated'],
  'item.reparsed': [
    'Данные со страницы загружены — проверьте и сохраните',
    'Page data loaded — check it and save',
  ],
  'item.deleted': ['Элемент удалён из библиотеки', 'Removed from your library'],
  'item.back': ['← В библиотеку', '← To the library'],
  'item.savedAt': ['Сохранено', 'Saved'],
  'item.status': ['Статус', 'Status'],
  'item.statusHint': ['Виден только вам.', 'Visible only to you.'],
  'item.statusNone': ['Без статуса', 'No status'],
  'item.author': ['Автор', 'Author'],
  'item.domain': ['Домен', 'Domain'],
  'item.openSource': ['Открыть источник', 'Open the source'],
  'item.reparse': ['Обновить данные со страницы', 'Refresh page data'],
  'item.type': ['Тип', 'Type'],
  'item.url': ['Ссылка', 'Link'],
  'item.coverUrl': ['Обложка (URL)', 'Cover (URL)'],
  'item.note': ['Личная заметка', 'Personal note'],
  'item.noteHint': ['Видна только вам.', 'Visible only to you.'],
  'item.saving': ['Сохраняем…', 'Saving…'],
  'item.save': ['Сохранить', 'Save'],
  'item.edit': ['Править', 'Edit'],
  'item.yourNote': ['Ваша заметка', 'Your note'],
  'item.inPlaylists': ['В подборках', 'In collections'],
  'item.nowhere': ['Пока нигде.', 'Not anywhere yet.'],
  'item.buildOne': ['Соберите подборку', 'Build a collection'],
  'item.aroundLink': ['вокруг этой ссылки.', 'around this link.'],
  'item.hideParser': ['Скрыть данные парсера', 'Hide parser data'],
  'item.showParser': ['Показать данные парсера', 'Show parser data'],
  'item.deleteWarn': [
    'Удаление уберёт ссылку из всех ваших подборок.',
    'Deleting removes this link from all your collections.',
  ],
  'item.deleteTitle': ['Удалить из библиотеки?', 'Remove from the library?'],
  'item.deleteBody': ['«{title}» исчезнет из всех подборок.', '“{title}” disappears from every collection.'],
  'item.notFound': ['Элемент не найден', 'Item not found'],
  'item.notFoundBody': [
    'Возможно, он удалён или доступ к нему есть только у владельца.',
    'It may be deleted, or only its owner can see it.',
  ],
} satisfies Record<string, Pair>;
